var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 14.1654H4.66732C2.23398 14.1654 0.833984 12.7654 0.833984 10.332V5.66536C0.833984 3.23203 2.23398 1.83203 4.66732 1.83203H9.33398C9.60732 1.83203 9.83398 2.0587 9.83398 2.33203C9.83398 2.60536 9.60732 2.83203 9.33398 2.83203H4.66732C2.76065 2.83203 1.83398 3.7587 1.83398 5.66536V10.332C1.83398 12.2387 2.76065 13.1654 4.66732 13.1654H11.334C13.2407 13.1654 14.1673 12.2387 14.1673 10.332V6.9987C14.1673 6.72536 14.394 6.4987 14.6673 6.4987C14.9407 6.4987 15.1673 6.72536 15.1673 6.9987V10.332C15.1673 12.7654 13.7673 14.1654 11.334 14.1654Z",
    fill: "#6E7191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9992 8.5818C7.4392 8.5818 6.87254 8.40847 6.4392 8.05514L4.35253 6.38847C4.1392 6.21514 4.0992 5.9018 4.27254 5.68847C4.44587 5.47514 4.7592 5.43514 4.97253 5.60847L7.0592 7.27514C7.56587 7.68181 8.42586 7.68181 8.93253 7.27514L9.71919 6.64847C9.93253 6.47514 10.2525 6.50847 10.4192 6.72847C10.5925 6.9418 10.5592 7.2618 10.3392 7.42847L9.55253 8.05514C9.12586 8.40847 8.5592 8.5818 7.9992 8.5818Z",
    fill: "#6E7191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0007 5.83333C11.8073 5.83333 10.834 4.86 10.834 3.66667C10.834 2.47333 11.8073 1.5 13.0007 1.5C14.194 1.5 15.1673 2.47333 15.1673 3.66667C15.1673 4.86 14.194 5.83333 13.0007 5.83333ZM13.0007 2.5C12.3607 2.5 11.834 3.02667 11.834 3.66667C11.834 4.30667 12.3607 4.83333 13.0007 4.83333C13.6407 4.83333 14.1673 4.30667 14.1673 3.66667C14.1673 3.02667 13.6407 2.5 13.0007 2.5Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNotification);
export default __webpack_public_path__ + "static/media/sms-notification.7d708e762ff462d9fe50c30a1311284c.svg";
export { ForwardRef as ReactComponent };